import styled from "styled-components"
import { mobile } from "../responsive";
import Announcement from '../components/Announcement';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const Container = styled.div`
    /* width: 100vw; */
    height: 78vh;
    background: 
      linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)),
      url("https://firebasestorage.googleapis.com/v0/b/shop-d66d7.appspot.com/o/Cake%2FSite%2FCakes2.png?alt=media&token=767a2b28-d7b0-42f7-8a2e-a4fec1fc0b1f") center;
      background-size: cover;
      display: flex;
    align-items: center;
    justify-content: center;
`;
const Wrapper = styled.div`
  width: 40%;
  padding: 20px;
  /* background-color: white; */
  ${mobile({ width: "75%"})}
`;

const Title = styled.h1`
  font-size: 24px;
  display: flex;
  font-weight: 300;
  align-items: center;
  justify-content: center;
`;
const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 10px;
`;

const Input = styled.input`
  flex: 1;
  min-width: 40%;
  
  margin: 20px 10px 5px 5px;
  padding: 10px;
`;
const Agreement = styled.span`
  font-size: 12px;
  margin: 20px 0px;
`;
const Button = styled.button`
  width: 40%;
  border: none;
  padding: 15px 20px;
  background-color: teal;
  color: white;
  cursor: pointer;
`;


const Register = () => {
  return (
    <>
    <Navbar />
    <Announcement />
    <Container>
      <Wrapper>
        <Title>CREATE AN ACCOUNT</Title>
        <Form>
          <Input placeholder="name" />
          <Input placeholder="last name" />
          <Input placeholder="username" />
          <Input placeholder="email" />
          <Input placeholder="password" />
          <Input placeholder="confirm password" />
          <Agreement>By creating an account, I consent to the processing of my personal
            data in accordance with the <b>PRIVACY POLICY</b></Agreement>
          <Button>CREATE</Button>
        </Form>
      </Wrapper>
    </Container>
    <Footer />
    </>
  )
}

export default Register
